import React, { useState } from 'react';
import { editarSaldoInicial } from '../services/cuentasService';
import { mensajeAmigable } from '../utils/errores';
import { aNumero } from '../utils/validacion';
import CampoNumero from './CampoNumero';
import { useToast } from '../context/ToastContext';

// Corrige el saldo inicial (apertura) de una cuenta. El saldo actual se
// ajusta solo por la diferencia y el historial se recalcula.
export default function EditarSaldoInicialModal({ cuentaId, cuentaNombre, montoActual, onCerrar, onGuardado }) {
  const { mostrarToast } = useToast();
  const [monto, setMonto] = useState(String(montoActual ?? ''));
  const [guardando, setGuardando] = useState(false);

  const guardar = async () => {
    if (aNumero(monto) === null) { mostrarToast('Escribe el saldo (solo números)', 'error'); return; }
    setGuardando(true);
    try {
      await editarSaldoInicial(cuentaId, monto);
      mostrarToast('Saldo inicial corregido ✅', 'exito');
      onGuardado?.(); onCerrar();
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
    finally { setGuardando(false); }
  };

  const input = { width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };

  return (
    <div onClick={onCerrar} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 1200 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: 'white', borderRadius: '16px', width: '100%', maxWidth: '400px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #F3F4F6' }}>
          <h3 style={{ margin: 0, color: 'var(--color-primario,#DB2777)', fontSize: '18px' }}>🏦 Editar saldo inicial</h3>
          <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#6B7280' }}>{cuentaNombre} · el saldo actual se ajusta solo.</p>
        </div>
        <div style={{ padding: '20px' }}>
          <label style={{ fontSize: '12px', color: '#6B7280', fontWeight: 600, display: 'block', marginBottom: '4px' }}>Saldo inicial correcto (L)</label>
          <CampoNumero valor={monto} onChange={setMonto} deshabilitado={guardando} autoFocus
            negativos prefijo="L" placeholder="0.00" estilo={input} />
          <p style={{ margin: '6px 0 16px', fontSize: '11px', color: '#9CA3AF' }}>Para tarjeta de crédito con deuda, en negativo (ej. -5000).</p>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button onClick={onCerrar} disabled={guardando}
              style={{ flex: '0 0 auto', padding: '12px 18px', background: 'white', border: '1px solid #D1D5DB', borderRadius: '10px', cursor: 'pointer', color: '#6B7280', fontWeight: 600 }}>Cancelar</button>
            <button onClick={guardar} disabled={guardando}
              style={{ flex: 1, padding: '12px', backgroundColor: guardando ? '#9CA3AF' : 'var(--color-primario,#DB2777)', color: 'white', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: 'bold', cursor: guardando ? 'wait' : 'pointer' }}>
              {guardando ? '⏳...' : 'Guardar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
